import React from "react";
import "../css/about.scss";
import { Link } from "react-router-dom";
import siteConfig from "../siteConfig";

function About() {
  return (
    <main className="about">
      <section className="about-hero">
        <img
          src="/img/editorial/about.jpg"
          alt="Material samples, glaze tiles and packaging on a design worktable"
        />
        <div>
          <p className="eyebrow">Our approach</p>
          <h1>Useful forms, explained with care.</h1>
        </div>
      </section>
      <section className="about-copy section-pad">
        <p className="eyebrow">{siteConfig.brandName}</p>
        <h2>A {siteConfig.operatingRegion} storefront for material-led objects.</h2>
        <div>
          <p>
            {siteConfig.brandName} brings together compact homeware, textiles, prints, food
            gifts and a small workshop listing. We describe how each object is
            meant to be used, what it is made from and what natural or handmade
            variation can look like.
          </p>
          <p>
            The catalog avoids invented origin stories and borrowed maker
            claims. Instead, it centres dimensions, texture, maintenance and
            safety—the details that help a piece live well after the photograph.
          </p>
        </div>
      </section>
      <section className="about-values section-pad">
        <article>
          <span>01</span>
          <h3>Clear materials</h3>
          <p>
            Composition, size, colour and care are stated on the product page.
          </p>
        </article>
        <article>
          <span>02</span>
          <h3>Original presentation</h3>
          <p>
            Product and editorial photography is created for this catalog
            without third-party logos.
          </p>
        </article>
        <article>
          <span>03</span>
          <h3>Practical support</h3>
          <p>
            One customer-care email connects orders, product questions and
            policy requests.
          </p>
        </article>
      </section>
      <section className="about-cta">
        <h2>Need to check a detail?</h2>
        <p>
          Ask about scale, material, care, delivery or an accessibility need
          before ordering.
        </p>
        <Link className="button-link" to="/contact">
          Contact customer care
        </Link>
      </section>
    </main>
  );
}

export default About;
